import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { popIn } from '../motion';
import { StatusChip, Status } from './StatusChip';
import { ProgressBar } from './Progress';

interface Props {
  src?: string | null;
  video?: boolean;
  /** 画像のサムネだが、開くと動画になる */
  playable?: boolean;
  status?: Status;
  progress?: number | null;
  shape?: 'wide' | 'square' | 'portrait';
  contain?: boolean;
  onClick?: () => void;
  alt?: string;
}

/** 作品1枚。生成中はぼかしと進捗、完了で鮮明に切り替わる。 */
export const MediaTile: React.FC<Props> = ({ src, video, playable, status = 'done', progress, shape = 'wide', contain, onClick, alt = '' }) => {
  const cls = [
    'v2-media',
    shape === 'square' && 'v2-media--square',
    shape === 'portrait' && 'v2-media--portrait',
    contain && 'v2-media--contain',
    (status === 'running' || status === 'waiting') && !src && 'v2-media--busy',
  ]
    .filter(Boolean)
    .join(' ');
  const busy = status === 'running' || status === 'waiting';

  return (
    <motion.button
      className={cls}
      variants={popIn}
      whileHover={{ y: -4, boxShadow: '0 18px 40px rgba(29,25,39,.14)' }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      layout
      aria-label={alt || undefined}
    >
      {src &&
        (video ? (
          <video src={src} muted playsInline loop preload="metadata" onMouseEnter={(e) => e.currentTarget.play().catch(() => undefined)} onMouseLeave={(e) => e.currentTarget.pause()} />
        ) : (
          <motion.img
            src={src}
            alt={alt}
            loading="lazy"
            initial={{ opacity: 0, scale: 1.06 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          />
        ))}
      {(video || playable) && src && !busy && status !== 'failed' && (
        <span className="v2-media-play">
          <span>
            <Play size={20} fill="currentColor" />
          </span>
        </span>
      )}
      {busy && (
        <motion.div className="v2-media-veil" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <StatusChip status={status} />
          <div style={{ width: '70%' }}>
            <ProgressBar value={progress} />
          </div>
        </motion.div>
      )}
      {status === 'failed' && (
        <span className="v2-media-corner">
          <StatusChip status="failed" />
        </span>
      )}
    </motion.button>
  );
};
